import * as React from 'react';

import { Icon } from '../icon/icon.tsx';
import { BreadcrumbItem } from './breadcrumb-item/breadcrumb-item.tsx';

import './breadcrumb-group.css';

interface BreadcrumbGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  breadcrumbs: Array<string>;
  active: number;
}

const BreadcrumbGroup = React.forwardRef<HTMLDivElement, BreadcrumbGroupProps>(
  ({ breadcrumbs, active, onClick, ...props }, ref) => {
    const [internalActive, setInternalActive] = React.useState(active);
    return (
      <div className="breadcrumb-group" ref={ref} {...props}>
        {breadcrumbs.map((breadcrumb, index) => {
          return (
            <div className="breadcrumb-group-inner" key={breadcrumb}>
              <BreadcrumbItem
                label={breadcrumb}
                isActive={internalActive === index}
                onClick={e => {
                  setInternalActive(index);
                  onClick?.(e);
                }}
              />
              {index !== breadcrumb.length - 1 && (
                <Icon
                  type="arrow-right"
                  color="var(--color_primary-dark)"
                  style={{ marginLeft: '4px', marginRight: '4px' }}
                />
              )}
            </div>
          );
        })}
      </div>
    );
  },
);

export { BreadcrumbGroup };
